import {Component, Injector, OnInit} from '@angular/core';
import {RankService} from '../services/rank.service';
import * as moment from 'moment';
import {UserService} from '../services/user.service';
import {PomodoroRepository} from '../Models/PomodoroRepository';
import {SettingService} from '../services/setting.service';
import {SnackBarService} from '../services/snack-bar.service';
import 'moment-duration-format';
import {Setting} from '../Models/setting.model';
import {formatDate} from '@angular/common';
import {Router} from '@angular/router';
import {ReminderSetMobileComponent} from '../dialogs/reminder-set-mobile/reminder-set-mobile.component';
import {StatisticsPopupComponent} from '../dialogs/statistics-popup/statistics-popup.component';
import {MatDialog} from '@angular/material/dialog';
@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {
  public spinner = false;
  public showPagination = false;
  public userTab: any = 'tab1';
  public allUserTab: any = 'tab1';
  public rankLength: number;
  public todayMainRank;
  public yesterdayMainRank;
  public weekMainRank;
  public monthMainRank;
  public yearMainRank;
  public mainRankModule;
  public isLoggedIn = false;
  public mainRankSpinner = false;
  public loadSpinner = false;
  public p = 1;
  public collection: any;
  public youAre = false;
  public userId = localStorage.getItem('userOfId');
  public statisticsProfile;
  public setting: Setting = new Setting();
  public isOnline;
  public onlineTime;
  public onlineMode = false;
  public offlineMode = true;
  public lastOnlineRecently = false;
  public pomodoroRepository: PomodoroRepository;
  private changeSpinner = false;
  public currentTime = (new Date(formatDate(new Date(), 'yyyy-MM-dd', 'fa-IR')).getTime() / 1000);
  public remainDays: any;
  public myTime: any;
  public showDays = [];
  constructor(private rankService: RankService,
              private userService: UserService,
              injector: Injector,
              private settingService: SettingService,
              private snackBarService: SnackBarService,
              private router: Router,
              private dialog: MatDialog) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }
  ngOnInit(): void {
    // @ts-ignore
    // this.setting.be_in_pomodoro_ranking = this.pomodoroRepository.beInPomodoroRanking;
    const token = localStorage.getItem('token');
    this.isLoggedIn = token !== null;
    if (token !== null) {
      this.getSettingInformation();
      this.getCurrentUserInfo();
    }
    this.rankOfToday();
    // this.pomodoroRepository.getTokenDoneTime();
  }
  rankOfYear(): any{
    this.mainRankModule = this.yearMainRank;
    this.mainRankSpinner = true;
    this.spinner = true;
    this.rankService.ranking().subscribe(
      (data) => {
        this.yearMainRank = data.data;
        this.mainRankSpinner = false;
        this.spinner = false;
        this.mainRankModule = this.yearMainRank;
        if (this.mainRankModule.length > 20) {
          this.showPagination = true;
        }
      }
    );
  }
  rankOfToday(): any{
    this.spinner = true;
    this.mainRankModule = this.todayMainRank;
    this.rankService.todayAllRank().subscribe(
      (data) => {
        this.todayMainRank = data.data;
        this.mainRankModule = this.todayMainRank;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < data.data.length ; i++){
          if (data.data[i].online_at){
            const date = data.data[i].online_at.substr(0, 10);
            this.remainDays = (new Date(date).getTime() / 1000);
            const res = this.currentTime - this.remainDays;
            const resDate = (res / 86400);
            this.mainRankModule[i].online_at = Math.floor(resDate);
            if (this.mainRankModule[i].online_at != null && this.mainRankModule[i].online_at < 25){

            }
          }
        }
        this.spinner = false;
        if (this.mainRankModule.length > 20) {
          this.showPagination = true;
        }
      }
    );
  }
  rankOfYesterday(): any{
    this.spinner = true;
    this.mainRankModule = this.yesterdayMainRank;
    this.rankService.yesterdayAllRank().subscribe(
      (data) => {
        this.yesterdayMainRank = data.data;
        this.mainRankModule = this.yesterdayMainRank;
        this.spinner = false;
        if (this.mainRankModule.length > 20) {
          this.showPagination = true;
        }
      });
  }
  rankOfWeek(): any{
    this.spinner = true;
    this.mainRankModule = this.weekMainRank;
    this.rankService.weekAllRank().subscribe(
      (data) => {
        this.weekMainRank = data.data;
        this.mainRankModule = this.weekMainRank;
        this.spinner = false;
        if (this.mainRankModule.length > 20) {
          this.showPagination = true;
        }
      }
    );
  }
  rankOfMonth(): any{
    this.spinner = true;
    this.mainRankModule = this.monthMainRank;
    this.rankService.monthAllRank().subscribe(
      (data) => {
        this.monthMainRank = data.data;
        this.mainRankModule = this.monthMainRank;
        this.spinner = false;
        if (this.mainRankModule.length > 20) {
          this.showPagination = true;
        }
      }
    );
  }
  onClickUserRank(check): any{
    if (check === 1){
      this.userTab = 'tab1';
    }else if (check === 2){
      this.userTab = 'tab2';
    }else if (check === 3){
      this.userTab = 'tab3';
    }else if (check === 4){
      this.userTab = 'tab4';
    }
  }
  onClickAllUserRank(check): any{
    if (check === 1){
      this.allUserTab = 'tab1';
    }else if (check === 2){
      this.allUserTab = 'tab2';
    }else if (check === 3){
      this.allUserTab = 'tab3';
    }else if (check === 4){
      this.allUserTab = 'tab4';
    }
  }
  showMoment(sum): any{
    if (sum < 60){
      return moment().startOf('day').add(sum, 'minutes').format('HH:mm');
    } else {
      return moment.duration(sum, 'minutes').format('HH:mm');
    }
  }
  mustLoginAlert(): any{
    this.snackBarService.showSnackBar('برای شرکت در رتبه بندی کاربران ابتدا باید وارد حساب کاربری خود شوید.', 'red-snackbar');
  }
  rankingUpdate(value): any{
    this.pomodoroRepository.beInPomodoroRanking = value;
    this.loadSpinner = true;
    this.settingService.updateSetting(this.setting).subscribe(
      (data) => {
        this.setting = data.data;
        this.loadSpinner = false;
        if (this.pomodoroRepository.beInPomodoroRanking === true){
          if (localStorage.getItem('trans') === 'fa'){
            this.snackBarService.showSnackBar( 'شما به رتبه بندی عمومی کاربران اضافه شدید.', 'green-snackbar');
          } else if (localStorage.getItem('trans') === 'en'){
            this.snackBarService.showSnackBar( 'You have been added to the general rating of users.', 'green-snackbar');
          }
          // this.snackBarService.showSnackBar( '', 'green-snackbar');
        }
        if (this.pomodoroRepository.beInPomodoroRanking === false){
          if (localStorage.getItem('trans') === 'fa'){
            this.snackBarService.showSnackBar('شما از رتبه بندی عمومی کاربران حذف شدید.', 'red-snackbar');
          } else if (localStorage.getItem('trans') === 'en'){
            this.snackBarService.showSnackBar( 'You have been removed from the general rating of users.', 'red-snackbar');
          }
        }
        if (this.allUserTab === 'tab1'){
          this.rankOfToday();
        } else if (this.allUserTab === 'tab2') {
          this.rankOfWeek();
        } else if (this.allUserTab === 'tab2') {
          this.rankOfMonth();
        } else if (this.allUserTab === 'tab2') {
          this.rankOfYear();
        }
      }, (err) => {
        console.log(err);
        this.loadSpinner = false;
        this.snackBarService.showSnackBar('عملیات موفقیت آمیز نبود.', 'red-snackbar');
      }
    );
  }
  getCurrentUserInfo(): any{
    this.userService.getCurrentUserInfo().subscribe(
      (data) => {
        this.statisticsProfile = data.profile_photo_url;
      }, (error) => {
      if (error.status === 500 && error.error === 'Unauthenticated.'){
        this.pomodoroRepository.userIsLoggedIn = false;
        this.router.navigateByUrl('/login').then();
      }
    }
    );
  }
  getSettingInformation(): any{
    this.settingService.getSettingInformation().subscribe(
      (data) => {
        this.setting = data.data;
        localStorage.setItem('settingId', data.data.id);
      },
      (error) => {
        if (error.status === 500 && error.error === 'Unauthenticated.'){
          this.pomodoroRepository.prevLang = localStorage.getItem('trans');
          localStorage.clear();
          localStorage.setItem('trans', this.pomodoroRepository.prevLang);
          this.userService.logOut();
          this.pomodoroRepository.userIsLoggedIn = false;
          this.router.navigateByUrl('/login').then();
        }
      }
    );
  }
  openPopUp(): any{
    this.dialog.open(StatisticsPopupComponent);
  }
}
